import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import SessionNotificationServices from "./SessionNotification.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getSessionNotification = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_SESSION_NOTIFICATION,
      payload: true,
    });
    const resp = await SessionNotificationServices.getSessionNotification(
      filters
    );
    dispatch({
      type: actions.GET_SESSION_NOTIFICATION,
      payload: resp.data,
    });
    dispatch({
      type: actions.SESSION_NOTIFICATION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.SESSION_NOTIFICATION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_SESSION_NOTIFICATION,
      payload: false,
    });
  }
};

export const saveSessionNotification =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_SESSION_NOTIFICATION,
        payload: true,
      });
      const resp = await SessionNotificationServices.saveSessionNotification(
        req
      );
      const { data, count } =
        getState().sessionNotification.sessionNotification;
      dispatch({
        type: actions.GET_SESSION_NOTIFICATION,
        payload: {
          data: [...data, resp.data],
          count: count + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_SESSION_NOTIFICATION,
        payload: false,
      });
    }
  };

export const editSessionNotification =
  (req, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_SESSION_NOTIFICATION,
        payload: true,
      });
      const resp = await SessionNotificationServices.editSessionNotification(
        id,
        req
      );
      const { data, count } =
        getState().sessionNotification.sessionNotification;
      data[index] = resp.data;
      dispatch({
        type: actions.GET_SESSION_NOTIFICATION,
        payload: {
          data: data,
          count: count,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_SESSION_NOTIFICATION,
        payload: false,
      });
    }
  };

export const deleteSessionNotification =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_SESSION_NOTIFICATION,
        payload: true,
      });
      await SessionNotificationServices.deleteSessionNotification(id);
      const { data, count } =
        getState().sessionNotification.sessionNotification;
      data.splice(index, 1);
      dispatch({
        type: actions.GET_SESSION_NOTIFICATION,
        payload: {
          data: data,
          count: count - 1,
        },
      });
      dispatch({
        type: actions.SESSION_NOTIFICATION_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.SESSION_NOTIFICATION_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_SESSION_NOTIFICATION,
        payload: false,
      });
    }
  };

export const editJefe =
  (req, id, index, setLoading) => async (dispatch, getState) => {
    try {
      setLoading(true);
      const resp = await SessionNotificationServices.editSessionNotification(
        id,
        req
      );
      const { data, count } =
        getState().sessionNotification.sessionNotification;
      data[index] = resp.data;
      dispatch({
        type: actions.GET_SESSION_NOTIFICATION,
        payload: {
          data: data,
          count: count,
        },
      });
      dispatch({
        type: actions.SESSION_NOTIFICATION_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.SESSION_NOTIFICATION_FAIL,
        payload: message,
      });
    } finally {
      setLoading(false);
    }
  };
